export const gettingAdmins = "@/admin/@gettingAll";
export const getAdminsSuccess = "@/admin/@getAllSuccess";
export const getAdminsFailure = "@/admin/@getAllFailure";
